// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1wdvV","empty":"ModalGraph_empty__mHAlW"};